import { observer } from "mobx-react"
import * as React from "react"
import Select from "BookingSystem/components/Select"
import { Member } from "BookingSystem/db/Member"

interface Props {
  member: Member | null
  style?: Object
}

@observer
class MonthsDropdown extends React.Component<Props> {
  render() {
    const { member, style } = this.props
    let months = [
      "Month",
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ]

    return (
      <Select
        value={
          member && member.object.dobMonth.length > 0
            ? member.object.dobMonth
            : "Month"
        }
        onChange={(event: any) =>
          member != undefined
            ? (member.object.dobMonth = event.target.value)
            : null
        }
        style={style}
      >
        {months.map((month: string, i: number) => (
          <option key={i} value={i}>
            {month}
          </option>
        ))}
      </Select>
    )
  }
}

export default MonthsDropdown
